import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { MultiselectorClienteList } from "./multiselectorclientelist";
import { FiltroClienteComponent } from "./../../../../list/filtro"

type Entity = models.ClienteDeCliente;
export interface Props extends kea.ModalProps<number[], boolean, number> {
}


export interface State {
    filtro: models.FiltroCliente;
}
/**
* Modal de edición para un ClienteDeCliente
*/
export class ClienteDeClienteEdit extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            filtro: {
                Limite: 100,
                EsDeCredito: null
            }
        };
    }

    value = (props: Props, state: State) => props.value;
    idCliente = (props: Props, state: State) => props.params;

    getField = formfields(() => this.props);

    filtro = (props: Props, state: State) => state.filtro;
    items = createSelectorRx(this.filtro, this.idCliente, (filtro, idCliente) => observeResource(resources.ClienteDeCliente.ClientesFinalesPuedeAgregar, idCliente, filtro));

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }

    onChange = async (x: number[]) => {
        this.props.onChange(x);
    }

    render() {
        const value = this.props.value;
        const getField = this.getField;
        const items = this.items(this.props, this.state);

        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} />]}
                onClose={this.onCerrar}
                title="seleccionar clientes"
            >
                <kea.Title titulo={"Seleccionar clientes"} >
                </kea.Title>
                <FiltroClienteComponent value={this.state.filtro} onChange={x => this.setState({ filtro: x })} />
                <MultiselectorClienteList value={value} onChange={this.onChange} items={items} hideBusqueda />
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/edit/componentes/tabs/clientesfinales/edit.tsx